import { defineComponent as _defineComponent } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnIcon',
    props: {
        icon: { type: String, required: false },
        color: { type: String, required: false },
        size: { type: String, required: false },
        start: { type: Boolean, required: false },
        end: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        function useProps(props) {
            return props;
        }
        const props = __props;
        const typedProps = useProps(props);
        const __returned__ = { useProps, props, typedProps };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
